import type { PipeTransform } from '@angular/core';

import { Pipe } from '@angular/core';

@Pipe({ name: 'canExpand', standalone: true })
export class CanExpandPipe implements PipeTransform {
  transform(fn: (row: any) => boolean, row: any): boolean {
    return fn(row);
  }
}
